import React from "react"
import AppButton from "@/app/components/atomic/molecules/AppButton"

// Placeholder new-design error body — chrome (Header-new / Footer-new) is wired by the
// caller. The final design will replace the inner content; keep the bg-neutral / text-pale
// shell so it sits correctly between the V2 header and footer.
export default function NewErrorContent({children}: {children?: React.ReactNode}) {
    return (
        <main className="flex-1 bg-neutral text-pale flex flex-col items-center justify-center text-center gap-8 px-6 py-20">
            {children}

            <AppButton href="/" arrowPosition="before">
                Retour à l'accueil
            </AppButton>
        </main>
    )
}
